import { useMemo } from "react"
import ReactCountryFlag from "react-country-flag"
import Select from "react-select"
import countryList from "react-select-country-list"

interface CountrySelectProps {
    value?: string
    onChange: (value: string) => void
    placeholder?: string
    error?: boolean
}

const CountrySelect = ({
    value,
    onChange,
    placeholder = "Select country",
    error
}: CountrySelectProps) => {

    const options = useMemo(() => {
        return countryList().getData().map((country: any) => ({
            value: country.value,
            label: (
                <div className="flex items-center gap-2">
                    <ReactCountryFlag
                        svg
                        countryCode={country.value}
                        style={{ width: "1.25em", height: "1.25em" }}
                    />
                    <span>{country.label}</span>
                </div>
            )
        }))
    }, [])

    const selectedValue = options.find((opt) => opt.value === value)

    const customStyles = {
        control: (base: any, state: any) => ({
            ...base,
            minHeight: "42px",          // 👈 height
            height: "42px",
            borderColor: state.isFocused ? "#FF5200" : (error ? "#f87171" : base.borderColor), // pink-500
            borderRadius: "6px",
            boxShadow: state.isFocused ? "0 0 0 1px #FF5200" : "none",
            "&:hover": {
                borderColor: "#FF5200"
            }
        }),

        menuPortal: (base: any) => ({
            ...base,
            zIndex: 9999
        })
    }

    return (
        <Select
            value={selectedValue}
            options={options}
            onChange={(option: any) => onChange(option.value)}
            placeholder={placeholder}
            isSearchable
            className="w-full"
            styles={customStyles}
            menuPortalTarget={typeof window !== "undefined" ? document.body : null}
            menuPosition="fixed"
        />

    )
}

export default CountrySelect
